var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeList } from '@or-sdk/base';
import { DataHubSvc, setDiff } from '@or-sdk/data-hub-svc';
export class Deployments {
    constructor(params) {
        const { token, discoveryUrl, accountId, dataHubSvcUrl } = params;
        this.dataHubSvc = new DataHubSvc({
            token,
            discoveryUrl,
            accountId,
            dataHubSvcUrl,
        });
    }
    listDeployments(params = {}, paginationOptions = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.dataHubSvc.makeRequest({
                method: 'GET',
                route: 'deployments',
                params: Object.assign(Object.assign(Object.assign({}, params), paginationOptions), this.dataHubSvc.isCrossAccount ? { accountId: this.dataHubSvc.currentAccountId } : {}),
            });
            return makeList(result);
        });
    }
    listActiveDeployments(projection = [], paginationOptions = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.listDeployments({
                query: {
                    dateDeactivated: 0,
                },
                projection,
            }, paginationOptions);
        });
    }
    listDeploymentsByBotId(botId, projection = []) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.listDeployments({
                query: {
                    botId,
                },
                projection,
            });
        });
    }
    listActiveDeploymentsByBotId(botId, projection = []) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.listDeployments({
                query: {
                    botId,
                    dateDeactivated: 0,
                },
                projection,
            });
        });
    }
    listDeploymentsByFlowId(flowId, projection = []) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.listDeployments({
                query: {
                    flowId,
                },
                projection,
            });
        });
    }
    listActiveDeploymentsByFlowId(flowId, projection = []) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.listDeployments({
                query: {
                    flowId,
                    dateDeactivated: 0,
                },
                projection,
            });
        });
    }
    getDeployment(id, params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.dataHubSvc.makeRequest({
                method: 'GET',
                route: `deployments/${id}`,
                params: Object.assign(Object.assign({}, Array.isArray(params) ? { projection: params } : params), this.dataHubSvc.isCrossAccount ? { accountId: this.dataHubSvc.currentAccountId } : {}),
            });
        });
    }
    deleteDeployment(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.dataHubSvc.makeRequest({
                method: 'DELETE',
                route: `deployments/${id}`,
                params: Object.assign({}, this.dataHubSvc.isCrossAccount ? { accountId: this.dataHubSvc.currentAccountId } : {}),
            });
        });
    }
    saveDeployment(source) {
        return __awaiter(this, void 0, void 0, function* () {
            return (source.id && source.id !== 'new') ? this.updateDeployment(source) : this.createDeployment(source);
        });
    }
    createDeployment(source) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.dataHubSvc.makeRequest({
                method: 'POST',
                route: 'deployments/new',
                data: {
                    deployment: Object.assign(Object.assign({}, source), { id: 'new' }),
                },
                params: Object.assign({}, this.dataHubSvc.isCrossAccount ? { accountId: this.dataHubSvc.currentAccountId } : {}),
            });
            return setDiff(source, result);
        });
    }
    updateDeployment(source) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.dataHubSvc.makeRequest({
                method: 'POST',
                route: `deployments/${source.id}`,
                data: {
                    deployment: source,
                },
                params: Object.assign({}, this.dataHubSvc.isCrossAccount ? { accountId: this.dataHubSvc.currentAccountId } : {}),
            });
            return setDiff(source, result);
        });
    }
}
//# sourceMappingURL=Deployments.js.map